/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AccessControl,
  AccessControlOptional,
  AccessControlMetaI,
  AccessControlTrackedI,
} from "./access-control";
import { AccessControlTracked, AccessControlMeta } from "./access-control";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSignupEligibilityStatus,
  ClassSignupEligibilityStatusOptional,
  ClassSignupEligibilityStatusMetaI,
  ClassSignupEligibilityStatusTrackedI,
} from "./class-signup-eligibility-status";
import {
  ClassSignupEligibilityStatusTracked,
  ClassSignupEligibilityStatusMeta,
} from "./class-signup-eligibility-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CountryPhoneCode,
  CountryPhoneCodeOptional,
  CountryPhoneCodeMetaI,
  CountryPhoneCodeTrackedI,
} from "./country-phone-code";
import {
  CountryPhoneCodeTracked,
  CountryPhoneCodeMeta,
} from "./country-phone-code";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Ethnicity,
  EthnicityOptional,
  EthnicityMetaI,
  EthnicityTrackedI,
} from "./ethnicity";
import { EthnicityTracked, EthnicityMeta } from "./ethnicity";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Gender,
  GenderOptional,
  GenderMetaI,
  GenderTrackedI,
} from "./gender";
import { GenderTracked, GenderMeta } from "./gender";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ItemInstanceFull,
  ItemInstanceFullOptional,
  ItemInstanceFullMetaI,
  ItemInstanceFullTrackedI,
} from "./item-instance-full";
import {
  ItemInstanceFullTracked,
  ItemInstanceFullMeta,
} from "./item-instance-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Language,
  LanguageOptional,
  LanguageMetaI,
  LanguageTrackedI,
} from "./language";
import { LanguageTracked, LanguageMeta } from "./language";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeEnum,
  ProgramTypeEnumOptional,
  ProgramTypeEnumMetaI,
  ProgramTypeEnumTrackedI,
} from "./program-type-enum";
import {
  ProgramTypeEnumTracked,
  ProgramTypeEnumMeta,
} from "./program-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReferralSource,
  ReferralSourceOptional,
  ReferralSourceMetaI,
  ReferralSourceTrackedI,
} from "./referral-source";
import { ReferralSourceTracked, ReferralSourceMeta } from "./referral-source";

export class DummyEnumTrackedI {}
export type DummyEnumMetaI = any;
export const DummyEnumMeta = MetaTypesBase.string;

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
